import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[sedsHoverLi]',
    standalone: false
})
export class SedsHoverLiDirective {
  @Input()
  isOpen?: boolean;
  @Output()
  isOpenChange = new EventEmitter<boolean>();

  @Input()
  settedIndex = -1;

  static currentTag = '';
  static currentIndex = -1;

  @HostListener('mouseenter', ['$event'])
  mouseHover(event: any) {
    SedsHoverLiDirective.currentTag = event.target.nodeName;
    SedsHoverLiDirective.currentIndex = this.settedIndex;
    this.isOpenChange.emit(true);
  }

  @HostListener('mouseleave', ['$event'])
  mouseOut(event: any) {
    setTimeout(() => {
      if (SedsHoverLiDirective.currentIndex === this.settedIndex) {
        if (SedsHoverLiDirective.currentTag === event.target.nodeName) {
          SedsHoverLiDirective.currentTag = '';
          SedsHoverLiDirective.currentIndex = -1;
          this.isOpenChange.emit(false);
        }
      } else {
        this.isOpenChange.emit(false);
      }
    }, 100);
  }
}
